import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import request from '../../../../../../services/network/request';
import { useAuth } from '../../../../../../auth/authProvider';

const ExclusaoCampanhaModal = ({ open, onClose, clientesData, refetch, setIsLoading }) => {
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });
  const { token } = useAuth();

  const onDelete = async () => {
    try {
      const response = await request.patch(
        `/backstage/comunidade/campanhas/${clientesData.id}`,
        { deletedAt: new Date() },
        {
          contentType: 'multipart/form-data',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setSnackbar({ open: true, message: response.message });
      setTimeout(() => {
        onClose();
        refetch();
      }, 2000);
    } catch (error) {
      setSnackbar({ open: true, message: error || 'Erro ao alterar campanha' });
    } finally {
      setIsLoading(false);
    }
  };
  const handleCloseDialogConfirmation = arg => () => {
    onClose();

    if (arg === 'confirm') {
      onDelete();
    } else if (arg === 'cancel') {
      onClose();
    }
  };

  return (
    <Dialog open={open} maxWidth="xs">
      <DialogTitle>
        <Typography>Atenção</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography color="textSecondary" gutterBottom>
          Tem certeza de que deseja excluir
          <br /> essa campanha?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleCloseDialogConfirmation('cancel')}>
          Cancelar
        </Button>
        <Button color="primary" onClick={handleCloseDialogConfirmation('confirm')}>
          Prosseguir
        </Button>
      </DialogActions>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        message={snackbar.message}
        onClose={() => setSnackbar({ open: false, message: '' })}
      />
    </Dialog>
  );
};

export default ExclusaoCampanhaModal;
